import React from "react"

import Layout from "layouts/default"
import Header from "components/components/header"
import Hello from "components/index/hello"
import Story from "components/index/story"
import PreviousProjects from "components/index/previous-projects"
import Contact from "components/index/contact"
import Seo from "components/search/seo"
import { pipkin, pipkinGame } from "components/search/structured-data"
import site from "data/site.json"

const IndexPage = () => (
  <Layout>
    <Seo
      title="Netspeak Games | Creators of Pipkin"
      description={site.description}
      path="/"
      image={pipkin.image}
      imageAlt={pipkin.imageAlt}
      entities={[pipkinGame]}
    />
    <Header version="index" />
    <Hello />
    <Story />
    <PreviousProjects />
    <Contact />
  </Layout>
)

export default IndexPage
